import { render, staticRenderFns } from "./Receipt.vue?vue&type=template&id=72dba45c&scoped=true"
import script from "./Receipt.vue?vue&type=script&lang=ts"
export * from "./Receipt.vue?vue&type=script&lang=ts"
import style0 from "./Receipt.vue?vue&type=style&index=0&id=72dba45c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72dba45c",
  null
  
)

export default component.exports